
<template>
  <div class="order">
    <div class="tableConBox">
      <div class="tableTem" @click="searchList=[]">
        <div class="HSpace1"></div>
        <div class="searchBox flex flex-align-center">
          <div class="searchCon clearfix">
            <span>订单记录</span>
            <div class="left monthBox clearfix">
              <!-- <div class="left" @click="cutMonth(0)">上一月</div> -->
              <!-- <el-date-picker
                                class="left"
                                v-model="yearMonth"
                                :picker-options="pickerOptions0"
                                type="month"
                                @change="cutDataFn"
                                placeholder="选择月">
              </el-date-picker>-->
              <!-- <div class="left" @click="cutMonth(1)">下一月</div> -->
            </div>
            <!-- <div class="left emp-name clearfix" v-if="nowType!='bar'"> -->
            <!-- <div class="left emp-name clearfix"> -->
            <!-- <input type="text" v-model="empName" placeholder="请输入员工姓名" />
                            <div class="emp-list" v-if="empNameData.length">
                                <ul>
                                    <li @click="nowEmpId = item[0];empNameData=[];empName=item[1];nowEmpName=item[1]" v-for="(item,index) in empNameData" :key="index">
                                        {{item[1]}}
                                    </li>
                                </ul>
            </div>-->
            <!-- </div> -->
            <!-- <div class="left emp-name" v-if="nowType!='bar'">
                            <el-select v-model="nowEmpId" placeholder="请选择员工">
                                <el-option
                                :key="0"
                                :label="'全部'"
                                :value="''">
                                </el-option>
                                <el-option
                                v-for="item in empNameData"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="search">
                            <button @click="search">查询</button>
            </div>-->
          </div>
        </div>
        <div class="HSpace2"></div>
        <div class="tableBox">
          <div class="tableBoxScroll">
            <table class="titleTable">
              <tr>
                <th style="width:10%">序号</th>
                <th style="width:10%">订单时间</th>
                <th style="width:10%">支付状态</th>
                <th style="width:10%">发货状态</th>
                <th style="width:10%">地址</th>
                <th style="width:10%">手机</th>
                <th style="width:10%">收货人</th>
                <th style="width:10%">总金额</th>
                <th style="width:10%">原料总数</th>
                <th style="width:10%">操作</th>
              </tr>
            </table>
            <div class="scrollBox">
              <div class="scroll">
                <table
                  class="conTable"
                  :class="{overLengthTable:ratingData.length>10}"
                  v-if="ratingData.length>0"
                >
                  <tr v-for="(item,ind) in ratingData" :key="ind">
                    <td style="width:10%">
                      <span v-text="1+ind+(nowPage-1)*size"></span>
                    </td>
                    <td style="width:10%;">{{item.addTime | dateForGradePage}}</td>
                    <td
                      style="width:10%;"
                      :class="item.payEnabled?'success':'false'"
                    >{{item.payEnabled?(item.channel?(item.channel=="pay.wechat.native"?"微信支付":"支付宝支付"):"已支付"):"未支付"}}</td>
                    <td
                      style="width:10%;"
                      :class="item.sendEnabled?'success':'false'"
                    >{{item.sendEnabled?"已发货":"未发货"}}</td>
                    <td style="width:10%;">{{item.address}}</td>
                    <td style="width:10%;">{{item.mobile}}</td>
                    <td style="width:10%;">{{item.name}}</td>
                    <td style="width:10%;">{{item.amount}}</td>
                    <td style="width:10%;">{{item.count}}</td>
                    <td style="width:10%;cursor:pointer;color:blue;">
                      <span @click="doShowDetail(item)">查看详情</span>
                    </td>
                  </tr>
                </table>
                <div class="no-data" v-else>暂无记录</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 分页器 -->
        <div class="pager flex flex-align-center">
          <div class="pagerCon clearfix">
            <span class="right">
              <el-pagination
                background
                layout="prev, pager, next"
                :page-size="size"
                :total="totalElements"
                :current-page.sync="nowPage"
                @current-change="handleCurrentChange"
              ></el-pagination>
            </span>
          </div>
        </div>
      </div>
    </div>
    <table id="scrollBox" style="display:none"></table>
    <el-dialog
            title="订单详情"
            :visible.sync="showDetail"
            width="30%">
            <div class="detail-list-tit">
                <span style="width:10%;">序号</span>
                <span style="width:20%;">商品名字</span>
                <span style="width:20%;">分类</span>
                <span style="width:15%;">单位</span>
                <span style="width:10%;">数量</span>
                <span style="width:10%;">金额</span>
                <span style="width:15%;">发货状态</span>
            </div>
            <div class="detail-list">
                <ul>
                    <li v-for="(item,index) in detailInfo" :key="index">
                        <span style="width:10%;">{{index+1}}</span>
                        <span style="width:20%;">{{item.productName}}</span>
                        <span style="width:20%;">{{item.typeName}}</span>
                        <span style="width:15%;">{{item.spec}}</span>
                        <span style="width:10%;">{{item.qty}}</span>
                        <span style="width:10%;">{{item.amount}}</span>
                        <span style="width:15%;cursor: pointer;" 
                        :class="item.sendEnabled?'send success':'send false'"
                        >{{item.sendEnabled?"已发货":"未发货"}}</span>
                    </li>
                </ul>
            </div>
        </el-dialog>
  </div>
</template>

<script type="text/javascript">
import { url } from "@/router/url.js";
import { BASE_URL } from "./../../../urlConfig";
export default {
  props: ["curStoreId", "pageSize"],
  data() {
    return {
      pickerOptions0: {
        //时间禁用,今天以后的时间禁用。
        disabledDate(time) {
          return (
            time.getTime() > Date.now() ||
            time.getTime() < new Date("2017,01,01").getTime()
          );
        }
      },
      totalElements: 0,
      ratingData: [],
      getBtn: true, // 控制翻页请求
      size: 15,
      nowPage: 0,
      detailInfo:[],//订单详情
      showDetail:false,
    };
  },
  watch: {},
  methods: {
    doShowDetail(item) {
      this.detailInfo = item.items;
      this.showDetail = true;
    },
    //日历插件
    cutDataFn() {
      this.yearMonth = new Date(this.yearMonth).Format("yyyy-MM");
    },
    handleCurrentChange(val) {
        this.getOrderInfo(val - 1);
        this.nowPage = val;
    },
    getOrderInfo(page) {
      this.$http({
        url: BASE_URL + "shop-list",
        method: "GET",
        params: {
          userName: this.userName,
          page,
          size: this.size
        }
      }).then(res => {
        console.log(res);
        this.ratingData = res.data.content;
        this.totalElements = res.data.totalElements;
      });
    }
  },
  created: function() {
    this.userName = localStorage.getItem("username");
  },
  activated: function() {
    this.getOrderInfo(0);
  }
};
</script>
<style lang="scss">
@import "./../../../../static/css/common.scss";
@import "./../../tableTemplate/tableTem.scss";
@import "./orderInfo.scss";
</style>



// WEBPACK FOOTER //
// orderInfo.vue?055ae1db